import Icon from '../components/Icon.vue'

Icon.register({"location-arrow":{"width":512,"height":512,"paths":[{"d":"M444.5 3.5L28.7 195.4C-19.2 217.8-3.2 288.2 47.9 288.2H223.8V464.1C223.8 515.2 294.2 531.2 316.6 483.3L508.5 67.5C524.5 29.1 482.9-12.5 444.5 3.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/location-arrow.js
// module id = null
// module chunks = 